.toggle-button {
  text-transform: none;
  // Without this, a narrow flex row wraps the label internally and grows the button taller
  // instead of overflowing. nowrap makes the label the shrink floor, so the row wraps as a whole.
  white-space: nowrap;
}

.toggle-button:global.MuiToggleButton-sizeSmall {
  line-height: 1.25;
}
